import { AutoComplete, Input, Tooltip } from "antd";
import { t } from "i18next";
import { SearchIcon, EditIcon, DetailIcon, PlusIcon, DeleteIcon, AscRed, DescGrey } from "../../../../asset";
import style from './vehiclePage.module.css'
import CustomTable from "../../../../component/table/CustomTable";
import PrimaryButton from "../../../../component/button/PrimaryButton";
import DeleteConfirmationModal from "../../../../component/modal/DeleteConfirmationModal";
import SuccessModal from "../../../../component/modal/SuccessModal";
import { useVehicle } from "./VehiclePage.hooks";
import Breadcumbs from '../../../../component/page-components/breadcumbs/breadcumbs';
import SelectSearch from "../../../../component/input/SelectSearch";

export default function VehicleList() {

    const {
        list,
        setDeleteConfirmationModalOpen,
        deleteConfirmationModalOpen,
        successModalOpen,
        totalData,
        doGetListVehicle,
        options,
        onSelect,
        onSearch,
        searchKeyword,
        doDeleteVehicle,
        selectedId,
        setSelectedId,
        selectedUpdatedAt,
        setSelectedUpdatedAt,
        selectedVehicleType,
        setSelectedVehicleType,
        selectedVehicleNo,
        setSelectedVehicleNo,
        toVehicleDetail,
        selectedDepotId,
        selectDepotId,
        listDropdown,
        sorting,
        doSort,
        statePageSize,
        handleChangeLimit,
        toVehicleEdit,
        onClear,
        toVehicleAdd,
        isLoaded,
        currentPage,
        onScroll,
        dropdownListLoading,
        onSearchDDS,
        depotKeyword,
    } = useVehicle();

    function deleteData(id, updated_at, vehicle_no, vehicle_type) {
        setSelectedId(id)
        setSelectedUpdatedAt(updated_at)
        setSelectedVehicleType(vehicle_type)
        setSelectedVehicleNo(vehicle_no)
        // doDeleteVehicle(id, updated_at)
        setDeleteConfirmationModalOpen(true)
    }

    const VehicleListColumn = [
        {
            title: (
                <div className="flex w-auto">
                    <span className="text-lg font-[500] text-[#222222]">
                        {t("VEHICLE_LIST:VEHICLE_ID_FIELD")}
                    </span>
                    <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                        <div className={style.SortArea}>
                            <Tooltip title={t("Asc")} color="#CF0000">
                                <img
                                    src={sorting === "id asc" ? AscRed : DescGrey}
                                    alt="asc"
                                    className={sorting === "id asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("id asc")}
                                />
                            </Tooltip>

                            <Tooltip title={t("Desc")} color="#CF0000">
                                <img
                                    src={sorting === "id desc" ? AscRed : DescGrey}
                                    alt="desc"
                                    className={sorting === "id desc" ? "w-[10px] h-[10px] cursor-pointer rotate-180 " : "w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("id desc")}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            dataIndex: 'vehicleId',
            key: 'vehicleId',
            render: (vehicleId) => <span>{vehicleId}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    Vehicle Ownership
                </span>
            ),
            dataIndex: 'vehicleOwnership',
            key: 'vehicleOwnership',
            render: (vehicleOwnership) => <span>{vehicleOwnership}</span>,
        },
        {
            title: (
                <div className="flex w-auto">
                    <span className="text-lg font-[500] text-[#222222]">
                        {t("VEHICLE_LIST:OWNER_NAME_FIELD")}
                    </span>
                    <div style={{ marginLeft: "10px", marginTop: "3px" }}>
                        <div className={style.SortArea}>
                            <Tooltip title={t("Asc")} color="#CF0000">
                                <img
                                    src={sorting === "owner_name asc" ? AscRed : DescGrey}
                                    alt="asc"
                                    className={sorting === "owner_name asc" ? "w-[10px] h-[10px] cursor-pointer" : "rotate-180 w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("owner_name asc")}
                                />
                            </Tooltip>

                            <Tooltip title={t("Desc")} color="#CF0000">
                                <img
                                    src={sorting === "owner_name desc" ? AscRed : DescGrey}
                                    alt="desc"
                                    className={sorting === "owner_name desc" ? "w-[10px] h-[10px] cursor-pointer rotate-180 " : "w-[10px] h-[10px] cursor-pointer"}
                                    onClick={() => doSort("owner_name desc")}
                                />
                            </Tooltip>
                        </div>
                    </div>
                </div>
            ),
            dataIndex: 'ownerName',
            key: 'ownerName',
            render: (ownerName) => <span>{ownerName}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    {t("VEHICLE_LIST:VEHICLE_TYPE_FIELD")}
                </span>
            ),
            dataIndex: 'vehicleType',
            key: 'vehicleType',
            render: (vehicleType) => <span>{vehicleType}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    {t("VEHICLE_LIST:LICENCE_PLATE_FIELD")}
                </span>
            ),
            dataIndex: 'licencePlate',
            key: 'licencePlate',
            render: (licencePlate) => <span>{licencePlate}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    {t("VEHICLE_LIST:SKILL_SET_FIELD")}
                </span>
            ),
            dataIndex: 'skillSet',
            key: 'skillSet',
            render: (skillSet) => <span>{skillSet}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    {t("VEHICLE_LIST:STATUS_FIELD")}
                </span>
            ),
            dataIndex: 'status',
            key: 'status',
            render: (status) => <span>{status}</span>,
        },
        {
            title: (
                <span className="text-lg font-[500] text-[#222222]">
                    {t("VEHICLE_LIST:ACTION_FIELD")}
                </span>
            ),
            dataIndex: 'action',
            key: 'action',
            render: (action) => (action),
        },
    ]

    const dataSource = list?.map((item) => ({
        vehicleId: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.vehicle_id}
            </span>
        ),
        vehicleOwnership: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.ownership === true ? 'Owned' : 'Rent/Outsource'}
            </span>
        ),
        ownerName: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.owner_name ? item.owner_name : "-"}
            </span>
        ),
        vehicleType: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.vehicle_type}
            </span>
        ),
        licencePlate: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.vehicle_no}
            </span>
        ),
        skillSet: (
            <span className="font-roboto text-lg text-[#222222]">
                {item.skill_set_name[0]}
            </span>
        ),
        status: (
            item.status === "A" ?
                <span className="font-roboto text-lg text-[#222222]">
                    <div className="bg-[#57C22D1A] rounded-[9px] text-roboto text-[#57C22D] text-[16px] w-fit py-[2px] px-[6px]">
                        Active
                    </div>
                </span> :
                <span className="font-roboto text-lg text-[#222222]">
                    <div className="bg-[#FFE5E5] rounded-[9px] text-roboto text-[#FF6868] text-[16px] w-fit py-[2px] px-[6px]">
                        Expired
                    </div>
                </span>
        ),
        action: (
            <div className="flex gap-[26px]">
                <Tooltip title={t("VEHICLE_LIST:EDIT_TOOLTIP")} color="#CF0000">
                    <button>
                        <img src={EditIcon} onClick={() => toVehicleEdit(item.vehicle_id)} alt="icon-edit" />
                    </button>
                </Tooltip>
                <Tooltip title={t("VEHICLE_LIST:DELETE_TOOLTIP")} color="#CF0000">
                    <button>
                        <img src={DeleteIcon} alt="icon-delete" onClick={() => deleteData(item.vehicle_id, item.updated_at, item.vehicle_no, item.vehicle_type)} />
                    </button>
                </Tooltip>
                <Tooltip title={t("VEHICLE_LIST:DETAIL_TOOLTIP")} color="#CF0000">
                    <button>
                        <img src={DetailIcon} alt="icon-detail" onClick={() => toVehicleDetail(item.vehicle_id)} />
                    </button>
                </Tooltip>
            </div>
        )
    }))
console.log("tes", listDropdown);
    return (
        isLoaded ?
            <div className='p-[24px] flex flex-col gap-[24px]'>

                <DeleteConfirmationModal
                    isOpen={deleteConfirmationModalOpen}
                    onOk={() => setDeleteConfirmationModalOpen(false)}
                    onCancel={() => doDeleteVehicle(selectedId, selectedUpdatedAt)}
                    closable={false}
                    width={440}
                    className={style.modalContainer}
                    okText="Cancel"
                    cancelText="Yes, Delete"
                    title="Delete Data?"
                    description={<p>Are you sure want to delete <br /> <strong>{selectedId} - {selectedVehicleType} - {selectedVehicleNo?.replaceAll('-', ' ')}?</strong></p>}
                />

                <SuccessModal
                    isOpen={successModalOpen}
                    onOk={() => doGetListVehicle(1, 10, selectedDepotId)}
                    closable={false}
                    width={280}
                    className={style.deleteModal}
                    okText="Ok"
                    title="Well Done"
                    description="Your data has been deleted"
                />

                <Breadcumbs
                    jmlLevel={3}
                    menuLevel1={`Master`}
                    menuLevel2={`Fleet`}
                    menuLevel3={`Vehicle`}
                />

                <h1 className='font-sans-bold text-2xl' id='title'>{t("VEHICLE_LIST:TITLE")}</h1>

                <div className={style.headerContainer + ' flex justify-between items-center'}>
                    <div className="flex gap-[16px]">
                        <AutoComplete
                            options={options}
                            onSelect={onSelect}
                            allowClear={true}
                            onClear={() => onClear()}
                        // suffixIcon={<img src={SearchIcon} />}
                        >
                            <Input
                                placeholder={"Search by Vehicle Type"}
                                height={47}
                                onChange={(event) => onSearch(event)}
                                suffix={<img src={!searchKeyword ? SearchIcon : null} />}
                                style={{ fontSize: "20px" }}
                            />
                        </AutoComplete>

                        {/* TEMPERORY CODE, IF THERE IS TIME FOR OPTIMIZATION DO THIS PROPERLY ~~~ (note to Hafizh :D) */}
                        {/* {
                            listDropdown?.length !== 0 ? */}

                            <SelectSearch onScroll={(event) => onScroll(event, 'depotList')} keyword={depotKeyword} onChange={(value) => onSearchDDS(value, 'depotList')} onSelect={(value) => selectDepotId(value, 1, 10)} width={292} options={listDropdown} loading={dropdownListLoading} value={selectedDepotId} />

                            {/* :

                            null
                        } */}
                    </div>

                    <PrimaryButton disabled={listDropdown?.length===0} text={t("VEHICLE_LIST:ADD_VEHICLE_BUTTON")} prefixIcon={<img src={PlusIcon} alt="icon-plus" />} action={() => toVehicleAdd()} />

                </div>

                <div className={style.tableContainer}>

                    <CustomTable currentPage={currentPage} columns={VehicleListColumn} data={dataSource} pageLimit={statePageSize} onChange={(page, pageSize) => handleChangeLimit(page, pageSize, selectedDepotId)} total={totalData} showPagination />

                </div>
            </div>
            :
            ''
    );
}